import './style/index.scss';

window.addEventListener('DOMContentLoaded', () => {
  const messageElement = document.getElementById('message');
  messageElement!.innerHTML = '☕ TypeScript Template';
});
